import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { client as apollo } from 'cccisd-apollo';
import ExportStatus from '../Status/ExportStatus.js';
import licenseQuery from './productLicenses.graphql';
import assignmentCourseQuery from './assignmentCourseQuery.graphql';
import completedDateRender from './CompletedDateRender';
import { getAssignmentStatus } from './AssignmentStatus';
import scoreRender from './ScoreRender';
import CertificateRender from './Certificate';
const Fortress = window.cccisd.fortress;

const CourseProgress = props => {
    const [projectId, setProjectId] = useState(null);
    const [assignmentList, setAssignmentList] = useState([]);

    const [assignmentSettings, setAssignmentSettings] = useState([]);
    const [deploymentList, setDeploymentList] = useState([]);
    const [fullDeploymentList, setFullDeploymentList] = useState(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function start() {
            await getLicenseData();
        }
        start();
    }, []);

    async function getLicenseData() {
        const res = await apollo.query({
            query: licenseQuery,
            fetchPolicy: 'network-only',
            variables: {
                pawnId: Fortress.user.acting.id,
            },
        });

        const productList = res.data.products.productList;
        const deployments = res.data.deployments.deploymentList;
        const licensedProducts = [];
        const deploymentIds = deployments.map(item => item.deploymentId);

        setFullDeploymentList(deployments);
        setDeploymentList(deploymentIds);

        productList.forEach(item => {
            if (item.ownedLicense.licenseId) {
                licensedProducts.push(`${item.handle}_training`);
            }
        });

        await getCourseData(licensedProducts);
    }

    async function getCourseData(availableProducts) {
        const res = await apollo.query({
            query: assignmentCourseQuery,
            fetchPolicy: 'network-only',
            variables: {
                availableProducts,
            },
        });

        const settings = res.data.groups.questproject.assignmentList.map(item => {
            return { id: item.assignmentId, settings: item.settings };
        });

        const dKey = [];

        setAssignmentSettings(settings);
        setProjectId(res.data.groups.questproject.group.groupId);

        const key = {
            ssgrin_35_training: 'S.S.GRIN 3-5',
            ssgrin_k2_training: 'S.S.GRIN K-2',
            ssgrin_ec_training: 'S.S.GRIN EC',
        };
        res.data.groups.questproject.assignmentList.forEach(assignment => {
            assignment.deploymentList.forEach(deployment => {
                dKey.push({
                    id: deployment.deploymentId,
                    label: key[deployment.deploymentHandle],
                });
            });
        });

        let dList = [];

        const aList = res.data.groups.questproject.assignmentList.map(assignment => {
            dList.push(
                ...assignment.deploymentList.map(deployment => {
                    return deployment.deploymentId;
                })
            );
            return assignment.assignmentId;
        });

        setAssignmentList(aList);
        setLoading(false);
    }

    const setColumnDefinitions = columns => {
        const currentSettings = assignmentSettings.find(item => item.id === props.assignmentId);

        let productHandle = '';
        try {
            productHandle = fullDeploymentList
                .find(item => item.deploymentId === props.deploymentId)
                .handle.replace('_training', '');
        } catch (e) {
            // won't be accurate but at least won't white screen
            productHandle = props.match.params.productHandle;
        }

        const statusColIndex = columns.findIndex(col => col.name.startsWith('assignmentProgressStatus'));
        if (statusColIndex !== -1) {
            columns[statusColIndex].render = p => getAssignmentStatus({ ...p, productHandle });
            columns[statusColIndex].sort = false;
            columns[statusColIndex].filter = false;
            columns.splice(statusColIndex + 1, 0, {
                name: 'license',
                label: 'License',
                render: p => {
                    const { row } = p;

                    const ownedLic = row.ownedLicenseList.find(lic => lic?.product?.handle === productHandle);
                    if (ownedLic && !ownedLic.isExpired) {
                        return 'Active';
                    }
                    if (ownedLic) {
                        return 'Expired';
                    }
                    return 'None';
                },
            });
        }

        const dateColIndex = columns.findIndex(col => col.name === 'assignmentProgress.completedDate');
        if (dateColIndex !== -1) {
            columns[dateColIndex].render = p => {
                return completedDateRender({
                    ...p,
                    productHandle,
                });
            };
        }

        const certificateColIndex = columns.findIndex(col => col.label === 'Certificate');
        if (certificateColIndex !== -1) {
            columns[certificateColIndex].render = p => {
                const { row } = p;

                if (getAssignmentStatus({ ...p, productHandle }).includes('Completed')) {
                    return (
                        <CertificateRender
                            certProps={{
                                deploymentId: props.deploymentId,
                                hide: false,
                                language: 'en',
                                forceName: row['user.fullName'],
                                settings: currentSettings.settings.navigationSettings.certificate,
                                actingPawnId: row['pawn.pawnId'],
                                actingPawnHash: row['pawn.pawnHash'],
                            }}
                        />
                    );
                }
            };
        }

        const scoreColumnIndex = columns.findIndex(col => col.label === 'Score');
        if (scoreColumnIndex !== -1) {
            columns[scoreColumnIndex].render = p => {
                return scoreRender({ ...p, productHandle });
            };
        }

        return columns;
    };

    return (
        !loading && (
            <div>
                <h1>Course Progress</h1>
                <ExportStatus
                    setColumnDefinitions={setColumnDefinitions}
                    projectId={projectId}
                    hideProjectDropdown
                    deploymentIdWhitelist={deploymentList}
                    assignmentId={assignmentList[0]}
                    assignmentIdWhitelist={assignmentList}
                    labelForQuest="Course"
                    labelForDeployment="Training"
                    labelForSurvey="Training"
                />
            </div>
        )
    );
};
const mapStateToProps = state => ({
    assignmentId: state.assignment.admin.currentAssignmentId,
    deploymentId: state.assignment.admin.currentDeploymentId,
});

CourseProgress.propTypes = {
    assignmentId: PropTypes.number,
    deploymentId: PropTypes.number,
};

export default connect(mapStateToProps)(CourseProgress);
